<template>
  <div class="avoid-page-break">
      <TestRow class="avoid-page-break" id="1001" :profileTest="profileTest" name="Balance (mBESS)"/>
  </div>
    
  
  
</template>

<script>
import ProfileTest from "@/js/shared/classes/ProfileTest/SwayProfileTest";
import TestRow from "./TestRow";

export default {
  props: {
    profileTest: ProfileTest
  },
  name: "BalanceTests",
  components: {
    TestRow
  },
  
  
}
</script>

<style scoped>


</style>